import i18n from "../i18n";

const getSurvey = ({ lastActionCategory, bestStat, randomCategory }) => [
  {
    sectionTitle: "LES COMPÉTENCES",
    questions: [
      {
        title: `Qu’as-tu pu mettre en place en faveur de ta compétence en ${lastActionCategory} ? Comment as-tu réussi à réaliser ce défi ? Qu’est-ce que tu en retiens ? Comment feras-tu la prochaine fois ?`,
        answer: ""
      },
      {
        title: `Es-ce que tu te souviens de ton dernier défi en ${lastActionCategory} ? Je le trouve pas forcément évident à mettre en place, comment tu t’y ai pris ? Comment tu voudrais faire la prochaine fois ?`,
        answer: ""
      },
      {
        title:
          "Quel défi as-tu réussi à mettre en place et dont tu es le plus fier ? Pourquoi ? Comment tu t’y es pris ?",
        answer: ""
      }
    ]
  },
  {
    sectionTitle: "QUESTIONS RELATIVES AU MOIS",
    questions: [
      {
        title: `Si tu avais un conseil à donner à l’équipe pour progresser en ${bestStat} ça serait quoi ?`,
        answer: ""
      },
      {
        title: `Selon toi et dans l’objectif de faire progresser l’équipe, qu’est-ce qu’on pourrait mettre en place pour améliorer notre ${randomCategory} ?`,
        answer: ""
      }
    ]
  },
  {
    sectionTitle: "QUESTIONS FIXES POUR FAVORISER LA PROACTIVITE",
    questions: [
      {
        title:
          "Quelle est l’initiative pro-active dont tu es le plus fier le mois dernier ? Est-ce que tu peux m’en dire plus ?",
        answer: ""
      },
      {
        title:
          "Quelles sont tes idées pour augmenter le chiffre d'affaires ? Réduire les coûts ? Augmenter la productivité de l’équipe ? Améliorer les process ? Comment tu penses qu’on pourrait faire mieux ? Quelle réunion pourrions-nous supprimer ?",
        answer: ""
      }
    ]
  },
  {
    sectionTitle: "MANAGEURS COACHS",
    questions: [
      {
        title:
          "Qu’est-ce que tu as le plus en tête en ce moment ? Quels sont sont tes priorités ? Comment tu comptes t’y prendre pour bien les gérer ?",
        answer: ""
      },
      {
        title:
          "Qu’est-ce que je peux faire pour t’aider ? Pour te faire gagner du temps ?",
        answer: ""
      }
    ]
  },
  {
    sectionTitle: "MOTIVATION ET SENS",
    questions: [
      {
        title:
          "Qu’est-ce que tu aimes dans ton travail ? Qu’est-ce que tu aimerais encore plus faire/plus souvent ?",
        answer: ""
      },
      {
        title:
          "Quels sont les projets que tu as le plus envie de faire ? Pourquoi ?",
        answer: ""
      },
      {
        title:
          "Comment tu résumerais la mission que s’est donnée l’entreprise ? (question sur le sens dans l’objectif de re-motiver)",
        answer: ""
      },
      {
        title: "Qu’est-ce que tu aimes moins faire ? Pourquoi ?",
        answer: ""
      },
      {
        title: "Quel serait l’idéal pour toi en matière d’organisation ?",
        answer: ""
      }
    ]
  }
];
const shuffle = a => {
  let j, x, i;
  for (i = a.length - 1; i > 0; i--) {
    j = Math.floor(Math.random() * (i + 1));
    x = a[i];
    a[i] = a[j];
    a[j] = x;
  }
  return a;
};

const getRandomNumber = length => {
  return Math.floor(Math.random() * length);
};

const categories = ["stress", "publicSpeaking", "teamCohesion", "proactivity"];

const generateSurvey = ({ stats, lastAction }) => {
  const lastActionCategory = lastAction
    ? i18n.t(lastAction.category)
    : i18n.t("leadership");
  // const lastActionCategory = lastAction ? lastAction.category : "leadership";
  const bestStat = i18n.t(
    Object.keys(stats).sort((a, b) => {
      return stats[b].experience - stats[a].experience;
    })[0]
  );
  const randomCategory = i18n.t(categories[getRandomNumber(categories.length)]);
  // const randomCategory = "leadership";
  const dynamicSurvey = getSurvey({
    lastActionCategory,
    bestStat,
    randomCategory
  });
  // random Sections
  let survey = shuffle(dynamicSurvey);
  let fundamentalSurvey = {
    sectionTitle: "ENTRETIEN INDIVIDUEL :",
    questions: [
      {
        title: `Qu’est-ce que je peux faire pour t’aider ? Pour te faire gagner du temps ?`,
        answer: ""
      },
      {
        title: `Qu’est-ce que tu aimes dans ton travail ? Qu’est-ce que tu aimerais encore plus faire/plus souvent ?`,
        answer: ""
      },
      {
        title: `Qu’est-ce que tu as le plus en tête en ce moment ? Quels sont sont tes priorités? Comment tu comptes t’y prendre pour bien les gérer ?`,
        answer: ""
      }
    ]
  };
  return {
    additionalNotes: "",
    _id: "",
    fundamentalSurvey,
    survey
  };
};

export default generateSurvey;
